module.exports = __webpack_public_path__ + "static/media/aim-twl-logo.00c06756.png";